export const EMPTY_PROFILE_INFO = {
  email: { value: '' },
  firstName: { value: '' },
  lastName: { value: '' },
  phoneNumber: { value: '' },
  password: { value: '' },
};

export const EMPTY_PROFILE_INFO_VALUES = {
  email: '',
  firstName: '',
  lastName: '',
  phoneNumber: '',
  password: '',
};

export const EXAMPLE_PROFILE_INFO = {
  email: { value: 'johndoe@example.com' },
  firstName: { value: 'John' },
  lastName: { value: 'Doe' },
  phoneNumber: { value: 'password123' },
  password: { value: 'password123' },
};

export const DEFAULT_SUBMIT_TEXT = 'Submit';
